import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import SavedSearchTagContainer from "@/pages/saved-search/components/SavedSearchTagContainer";
import RHFTextField from "@/common/HOCs/rhf/text/RHFTextField";
import { useTranslation } from "@i18n";
import { twMerge } from "tailwind-merge";
import { useFieldArray, useFormContext } from "react-hook-form";
import { prepareDeletedFilters } from "@/pages/search/searchHooks/utils";
import { useState } from "react";
var SavedSearchCardEdit = function SavedSearchCardEdit(_ref) {
  var title = _ref.title,
    cancelEdit = _ref.cancelEdit,
    tagsList = _ref.tagsList;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(tagsList),
    initialTags = _useState[0],
    setInitialTags = _useState[1];
  var _useFormContext = useFormContext(),
    _useFormContext$formS = _useFormContext.formState,
    isValid = _useFormContext$formS.isValid,
    isDirty = _useFormContext$formS.isDirty,
    errors = _useFormContext$formS.errors,
    control = _useFormContext.control,
    getValues = _useFormContext.getValues,
    reset = _useFormContext.reset;
  var _useFieldArray = useFieldArray({
      control: control,
      name: "tags",
      keyName: "uuid"
    }),
    fields = _useFieldArray.fields,
    remove = _useFieldArray.remove,
    append = _useFieldArray.append;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "text-neutral-100 font-bold text-sm"
  }, t("search_title", {
    ns: "saved_search"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer",
    role: "button",
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        cancelEdit();
        reset();
      }
    },
    onClick: function onClick() {
      cancelEdit();
      reset();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/close-gray.svg",
    alt: "close-edit"
  }))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RHFTextField, {
    name: "title",
    placeholder: t("search_title", {
      ns: "saved_search"
    }),
    className: "w-full border border-solid border-gray-gainsboro rounded bg-white px-3 py-2 font-normal text-sm text-neutral-100"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement(SavedSearchTagContainer, {
    tags: fields,
    isEditing: true,
    onDeleteTag: function onDeleteTag(id) {
      var index = fields.findIndex(function (tag) {
        return tag.uuid === id;
      });
      if (index !== -1) {
        var test = prepareDeletedFilters(initialTags[index], initialTags);
        var arrayDifference = function arrayDifference(tags, fields) {
          return fields.filter(function (field) {
            return !tags.some(function (tag) {
              if (tag.type === 'range') {
                return tag.filterField === field.filterField;
              }
              return tag.id === field.id;
            });
          });
        };
        var indexesToRemove = arrayDifference(test, fields).map(function (field) {
          return fields.findIndex(function (tag) {
            return tag.uuid === field.uuid;
          });
        });
        remove(indexesToRemove);
        setInitialTags(test);
      }
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-px w-full bg-gray-gainsboro"
  }), /*#__PURE__*/React.createElement("button", {
    className: twMerge("bg-primary text-white font-bold text-sm border-none rounded py-2 px-3 w-56 mx-auto disabled:bg-neutral-60 disabled:text-neutral-70 leading-6 text-center"),
    disabled: !isValid || !isDirty
  }, t("save_changes", {
    ns: "saved_search"
  })))));
};
export default SavedSearchCardEdit;